<template>
  <div v-if="show" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <h3>Create Support Agreement</h3>
      <form @submit.prevent="createSupportAgreement">
        <div class="form-group">
          <label>Quote ID:</label>
          <input type="text" :value="`QU-${String((quote && quote.id) || '').padStart(4,'0')}`" readonly>
        </div>
        
        <div class="form-group">
          <label>Locker Combination:</label>
          <input type="text" :value="(quote && quote.locker_name) || 'N/A'" readonly>
        </div>
        
        <div class="form-group">
          <label>Project:</label>
          <input type="text" :value="(quote && quote.projectName) || 'N/A'" readonly>
        </div>
        
        <div class="form-group">
          <label>Agreement Type:</label>
          <select v-model="form.agreementType" required>
            <option value="">Select Agreement Type</option>
            <option value="SalesAgreement">Sales Agreement</option>
            <option value="SalesServiceAgreement">Sales & Service Agreement</option>
            <option value="SupportOnboardingAgreement">Support & Onboarding Agreement</option>
          </select>
        </div>
        
        <h4>Purchaser Information</h4>
        <div class="form-group">
          <label>Purchaser Name:</label>
          <div class="input-with-clear">
            <input type="text" v-model="form.purchaser.name" @input="onChangeSetFieldLeaveBlankFalse('purchaser.name')">
            <button type="button" @click="clearField('purchaser.name')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Purchaser Address:</label>
          <div class="input-with-clear">
            <textarea v-model="form.purchaser.address" @input="onChangeSetFieldLeaveBlankFalse('purchaser.address')"></textarea>
            <button type="button" @click="clearField('purchaser.address')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Contact Name:</label>
          <div class="input-with-clear">
            <input type="text" v-model="form.purchaser.contact_name" @input="onChangeSetFieldLeaveBlankFalse('purchaser.contact_name')">
            <button type="button" @click="clearField('purchaser.contact_name')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Phone:</label>
          <div class="input-with-clear">
            <input type="tel" v-model="form.purchaser.phone" @input="onChangeSetFieldLeaveBlankFalse('purchaser.phone')">
            <button type="button" @click="clearField('purchaser.phone')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Email:</label>
          <div class="input-with-clear">
            <input type="text" v-model="form.purchaser.email" @input="onChangeSetFieldLeaveBlankFalse('purchaser.email')">
            <button type="button" @click="clearField('purchaser.email')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Building Name:</label>
          <div class="input-with-clear">
            <input type="text" v-model="form.building.name" @input="onChangeSetFieldLeaveBlankFalse('building.name')">
            <button type="button" @click="clearField('building.name')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Building Address:</label>
          <div class="input-with-clear">
            <input type="text" v-model="form.building.address" @input="onChangeSetFieldLeaveBlankFalse('building.address')">
            <button type="button" @click="clearField('building.address')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-group">
          <label>Install Date:</label>
          <div class="input-with-clear">
            <input type="date" v-model="form.install_date" @input="onChangeSetFieldLeaveBlankFalse('install_date')">
            <button type="button" @click="clearField('install_date')" class="clear-btn" title="Clear field">×</button>
          </div>
        </div>
        
        <div class="form-actions">
          <button type="submit" :disabled="isCreating">
            {{isCreating ? 'Creating...' : 'Create Agreement'}}
          </button>
          &nbsp;
          <button type="button" @click="closeModal">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { CallApi } from "../Utilities";

export default {
  name: 'CreateSupportAgreementModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    quote: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isCreating: false,
      form: {
        agreementType: '',
        purchaser: {
          name: '',
          address: '',
          contact_name: '',
          phone: '',
          email: ''
        },
        building: {
          name: '',
          address: ''
        },
        install_date: ''
      },
      leaveBlank: {
        'purchaser.name': false,
        'purchaser.address': false,
        'purchaser.contact_name': false,
        'purchaser.phone': false,
        'purchaser.email': false,
        'building.name': false,
        'building.address': false,
        'install_date': false
      }
    };
  },
  watch: {
    quote: {
      handler(newQuote) {
        if (newQuote) {
          this.prefillForm(newQuote);
        }
      },
      immediate: true
    }
  },
  methods: {
    prefillForm(quote) {
      // Pre-fill building name from project data
      if (quote.projectName) {
        this.form.building.name = quote.projectName;
      }
      
      // Try to prefill purchaser details from existing agreements
      if (quote.quote_generation_params) {
        try {
          const existingParams = JSON.parse(quote.quote_generation_params);
          if (existingParams.purchaser) {
            // Prefill all purchaser fields if they exist from previous agreements
            this.form.purchaser = {
              name: existingParams.purchaser.name || '',
              address: existingParams.purchaser.address || '',
              contact_name: existingParams.purchaser.contact_name || '',
              phone: existingParams.purchaser.phone || '',
              email: existingParams.purchaser.email || ''
            };
          }
          
          // Also prefill building details if available
          if (existingParams.building) {
            if (existingParams.building.name) {
              this.form.building.name = existingParams.building.name;
            }
            if (existingParams.building.address) {
              this.form.building.address = existingParams.building.address;
            }
          }
          
          // Prefill install date if available
          if (existingParams.install_date) {
            this.form.install_date = existingParams.install_date;
          }
        } catch (error) {
          console.warn('Could not parse existing quote generation params:', error);
          // Fall back to just using project name for building
        }
      }
    },
    
    clearField(fieldPath) {
      // Handle nested paths like 'purchaser.name'
      const paths = fieldPath.split('.');
      let target = this.form;
      
      for (let i = 0; i < paths.length - 1; i++) {
        target = target[paths[i]];
      }
      
      // Clear the field - set to empty string
      target[paths[paths.length - 1]] = '';
      
      // Mark this field as "leave blank"
      this.leaveBlank[fieldPath] = true;
    },
    
    onChangeSetFieldLeaveBlankFalse(fieldPath) {
      // If user types something after clearing, unset the leave-blank flag
      if (this.leaveBlank[fieldPath]) {
        this.leaveBlank[fieldPath] = false;
      }
    },
    
    async createSupportAgreement() {
      try {
        this.isCreating = true;
        
        // Basic validation for required document type
        if (!this.form.agreementType) {
          console.error('Agreement type is required');
          return;
        }
        
        // Build payload with leave-blank flags
        const payload = {
          quote_id: this.quote.id,
          document_type: this.form.agreementType,
          purchaser: this.form.purchaser || {},
          building: this.form.building || {},
          install_date: this.form.install_date || ''
        };
        
        // Add leave-blank flags for cleared fields
        Object.keys(this.leaveBlank).forEach(fieldPath => {
          if (this.leaveBlank[fieldPath]) {
            // Convert dot notation to hyphen for backend
            const flagKey = fieldPath.replace(/\./g, '-') + '-leave-blank';
            payload[flagKey] = true;
          }
        });
        
        console.log('Sending payload:', payload); // Debug log
        
        const response = await CallApi("POST", `/quotes/${this.quote.id}/support-agreement`, payload);
        
        if (response.success) {
          this.$emit('agreement-created', response);
          this.resetForm();
          this.closeModal();
        }
      } catch (error) {
        console.error('Error creating support agreement:', error);
        // You might want to show an error message to the user
      } finally {
        this.isCreating = false;
      }
    },
    
    closeModal() {
      this.resetForm();
      this.$emit('close');
    },
    
    resetForm() {
      this.form = {
        agreementType: '',
        purchaser: {
          name: '',
          address: '',
          contact_name: '',
          phone: '',
          email: ''
        },
        building: {
          name: '',
          address: ''
        },
        install_date: ''
      };
      // Reset leave-blank flags
      this.leaveBlank = {
        'purchaser.name': false,
        'purchaser.address': false,
        'purchaser.contact_name': false,
        'purchaser.phone': false,
        'purchaser.email': false,
        'building.name': false,
        'building.address': false,
        'install_date': false
      };
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.input-with-clear {
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.input-with-clear input,
.input-with-clear textarea {
  flex: 1;
  padding-right: 30px;
  margin-bottom: 0;
}

.clear-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
  margin: 0;
}

.input-with-clear textarea + .clear-btn {
  top: 10px;
  transform: none;
}

.clear-btn:hover {
  background: #cc0000;
}

</style>